import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

export const useFileHandler = ({ initialFile = null, maxSize }) => {
  const [file, setFile] = useState(initialFile);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [file]);

  const handleFile = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    if (maxSize && selectedFile.size > maxSize) {
      toast.error('El archivo debe tener menos de 5MB')
      e.target.value = ""
      return
    } 

    setFile(selectedFile);
  }

  const handleRemoveFile = () => {
    setFile(null);
  };
  
  const fileTypeDisplayName = useMemo(() => {
    if (!file) return '';

    if (file.type.startsWith('image/')) return 'Imagen';
    if (file.type.startsWith('video/')) return 'Video';

    return 'Documento';
  }, [file]);

  const formattedFileSize = useMemo(() => {
  if (!file?.size) return '0 Bytes';

  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const k = 1024;
  const i = Math.floor(Math.log(file.size) / Math.log(k));

  return `${parseFloat((file.size / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}, [file]);
  

  return {
    file,
    previewUrl,
    handleFile,
    handleRemoveFile,
    fileTypeDisplayName,
    formattedFileSize
  }
}